import HeaderBlog from "../components/HeaderBlog";
import ListaBlog from "../components/ListaBlog";
import Obs from "../components/Obs";
import TableBlog from "../components/TableBlog";
import TextoPadraoBlog from "../components/TextoPadraoBlog";
import TituloBlog from "../components/TituloBlog";
import AlertBlog from "../components/AlertBlog";
import Footer from "../components/Footer";


const FreelancerPj = () => {
    return (
        <>
            <HeaderBlog
                titulo="Freelancer PJ: guia completo de obrigações fiscais para quem presta serviço para empresas"
                subtitulo="Você fechou o contrato, entregou o projeto, recebeu o pagamento — mas e a parte fiscal? Nota fiscal, DAS, imposto retido, pró-labore. Este guia cobre tudo que você precisa saber e fazer todo mês, sem enrolação."
                data="20 de maio de 2025"
                tempoLeitura={9}
            />

            <TextoPadraoBlog
                texto={[
                    "Ser PJ é ótimo: você ganha mais, tem liberdade, escolhe seus projetos. Mas junto com essa liberdade vem uma responsabilidade que ninguém te explica na hora de assinar o contrato: a obrigação fiscal mensal que acompanha cada nota que você emite. Este guia existe para mudar isso.",
                ]}
            />

            <TituloBlog index={1} titulo="Para quem é este guia?" />

            <TextoPadraoBlog
                texto={[
                    "Se você se encaixa em algum desses perfis e presta serviço para empresas com CNPJ, este guia foi escrito para você:",
                ]}
            />

            <TableBlog titulos={["Área", "Descrição"]} conteudo={[
                {
                    situacao: "Desenvolvedor",
                    valor: "Dev front, back, mobile, fullstack contratado como PJ por startups ou agências",
                },
                {
                    situacao: "Designer",
                    valor: "UI/UX, gráfico, motion — entrega projetos e emite nota para o cliente",
                },
                {
                    situacao: "Redator / Copywriter",
                    valor: "Conteúdo, SEO, copy para marcas — pago por projeto ou por mês",
                },
                {
                    situacao: "Gestor de Tráfego",
                    valor: "Gerencia campanhas de clientes e recebe como PJ mensalmente",
                },
                {
                    situacao: "Consultor",
                    valor: "Estratégia, produto, marketing, RH — presta horas ou projetos para empresas",
                },
                {
                    situacao: "Produtor de Conteúdo B2B",
                    valor: "Video maker, editor, fotógrafo que atende empresas como fornecedor PJ",
                }]}
            />

            <TextoPadraoBlog
                texto={[
                    "O que você vai aprender neste guia:",
                ]}
            />

            <ListaBlog itens={[
                <>Como emitir nota fiscal corretamente</>,
                <>DAS: quando e como pagar</>,
                <>Rotina fiscal mensal completa</>,
                <>O que é imposto retido e como funciona</>,
                <>Pró-labore e distribuição de lucro</>,
                <>Erros que custam multa — e como evitar</>,
            ]} />

            <TituloBlog index={2} titulo="Nota fiscal: como emitir, quando emitir e o que não errar" />

            <TextoPadraoBlog
                texto={[
                    "A nota fiscal de serviço (NFS-e) é a sua prova de que o serviço foi prestado legalmente. Sem ela, a empresa contratante não pode deduzir o pagamento — e você pode perder o cliente por isso.",
                    "Veja como funciona a anatomia de uma nota fiscal real:"
                ]}
            />

            <TableBlog titulos={[]} conteudo={[
                {
                    situacao: "Valor bruto do serviço",
                    valor: "R$ 8.000,00",
                },
                {
                    situacao: "ISS retido na fonte",
                    valor: "– R$ 200,00 (2,5%)",
                },
                {
                    situacao: "IRRF retido na fonte",
                    valor: "– R$ 240,00 (3%)",
                },
                {
                    situacao: "Valor líquido recebido",
                    valor: "R$ 7.560,00",
                },
                {
                    situacao: "Você ainda paga o DAS sobre os R$ 8.000 →",
                    valor: "~R$ 480",
                }]}
            />

            <Obs texto="Onde emitir a nota: a NFS-e é emitida no portal da prefeitura da cidade onde sua empresa está registrada. Cada município tem seu sistema — São Paulo usa o NFS-e paulistano, mas outras cidades têm portais diferentes. Seu contador configura isso na abertura da empresa." />

            <TextoPadraoBlog
                texto={[
                    "Regra de ouro: emita a nota fiscal antes de receber — ou no mesmo dia. Nunca receba sem emitir a nota. Além de ser obrigatório, é o documento que comprova que você prestou o serviço caso haja qualquer disputa."
                ]}
            />

            <TituloBlog index={3} titulo="Imposto retido na fonte: o que é e o que fazer com ele" />

            <TextoPadraoBlog
                texto={[
                    "Esse é o ponto que mais confunde freelancers PJ. Quando uma empresa te paga e retém imposto, ela está recolhendo esse imposto em seu nome antes de te repassar o dinheiro. Você não perdeu essa verba — ela foi para o governo no seu lugar."
                ]}
            />

            <TableBlog titulos={["Imposto", "Alíquota", "Tipo"]} conteudo={[
                {
                    situacao: "ISS: Imposto Sobre Serviços — recolhido pela prefeitura",
                    valor: "2% a 5%",
                    extraOne: "Municipal",
                },
                {
                    situacao: "IRRF: Imposto de Renda Retido na Fonte pela empresa pagadora",
                    valor: "1,5% a 4,8%",
                    extraOne: "Federal",

                },
                {
                    situacao: "PIS/COFINS/CSLL: Retidos pela empresa tomadora em casos específicos",
                    valor: "4,65%",
                    extraOne: "Federal",

                },
                {
                    situacao: "DAS: Simples Nacional — pago por você, não retido",
                    valor: "6% +",
                    extraOne: "Simples Nacional",

                }]}
            />

            <Obs texto="Atenção ao ISS: empresas do Simples Nacional têm o ISS embutido no DAS. Se o cliente reter ISS na fonte e você já pagou no DAS, pode haver dupla tributação. Seu contador precisa configurar a nota fiscal corretamente para evitar isso." />

            <TituloBlog index={4} titulo="DAS: o que é, como calcular e quando pagar" />

            <TextoPadraoBlog
                texto={[
                    "O DAS (Documento de Arrecadação do Simples Nacional) é a guia unificada que reúne todos os tributos federais, estaduais e municipais da sua empresa em um único boleto mensal. Para a maioria dos freelancers PJ no Simples, é a principal obrigação do mês."
                ]}
            />

            <TableBlog titulos={["Passo a passo", "Prazo"]} conteudo={[
                {
                    situacao: "Apure o faturamento do mês anterior: Some todas as notas fiscais emitidas no período",
                    valor: "Todo mês",
                },
                {
                    situacao: "Acesse o PGDAS-D no portal do Simples: Portal e-CAC da Receita Federal → Simples Nacional → PGDAS-D",
                    valor: "Até dia 20",
                },
                {
                    situacao: "Informe o faturamento e gere o DAS: O sistema calcula a alíquota automaticamente com base no seu histórico de faturamento",
                    valor: "Até dia 20",
                },
                {
                    situacao: "Pague o DAS via banco ou app: Boleto, Pix ou débito em conta. Atraso gera multa de 0,33% ao dia + SELIC",
                    valor: "Vence dia 20",
                },
                {
                    situacao: "Guarde o comprovante: O comprovante de pagamento do DAS é documento fiscal — guarde por pelo menos 5 anos",
                    valor: "Sempre",
                }]}
            />

            <AlertBlog texto="DAS zerado não precisa ser pago — mas precisa ser declarado. Se você não teve faturamento em um mês, ainda assim precisa acessar o PGDAS-D e informar faturamento zero. Meses sem declaração acumulam pendências que podem travar o CNPJ." />

            <TituloBlog index={5} titulo="Pró-labore e distribuição de lucro: como você se paga" />

            <TextoPadraoBlog
                texto={[
                    "Um dos maiores erros de freelancers PJ iniciantes: misturar a conta da empresa com a conta pessoal e sacar o que precisar quando precisar. Isso cria um caos contábil e pode te prejudicar em uma fiscalização.",
                    "A forma correta de se remunerar como dono da empresa tem duas partes:"
                ]}
            />

            <TableBlog titulos={[]} conteudo={[
                {
                    situacao: "Pró-labore: Seu \"salário\" como sócio da empresa — paga INSS e IR sobre esse valor",
                    valor: "Mín. 1 salário mínimo",
                },
                {
                    situacao: "Distribuição de lucro: O restante que sobra após pagar DAS, pró-labore e despesas — isento de IR",
                    valor: "Isento de IR",
                },
                {
                    situacao: "INSS sobre o pró-labore: Contribuição previdenciária — garante aposentadoria, auxílio e benefícios do INSS",
                    valor: "11% do pró-labore",
                }]}
            />

            <Obs texto="Pró-labore baixo + distribuição de lucro alta = menos imposto e mais dinheiro no bolso. Mas precisa estar dentro das regras. Um contador define o equilíbrio certo para o seu perfil." />

            <TituloBlog index={6} titulo="A rotina fiscal mensal do freelancer PJ" />

            <TextoPadraoBlog
                texto={[
                    "Veja exatamente o que precisa acontecer todo mês para sua empresa ficar em dia:"
                ]}
            />

            <ListaBlog itens={[
                <><b>Emita a NFS-e antes ou no dia do recebimento: </b> Nunca receba sem nota emitida — é obrigação legal e protege você no contrato</>,
                <><b>Envie a nota para o cliente e confira os dados: </b> CNPJ, razão social, descrição do serviço e valor — erros geram retrabalho e atraso no pagamento</>,
                <><b>Declare e pague o DAS no PGDAS-D: </b> Baseado no faturamento do mês anterior. Atraso = multa automática</>,
                <><b>Faça a folha de pró-labore e recolha o INSS: </b> GPS (Guia da Previdência Social) — vence todo dia 20 do mês seguinte</>,
                <><b>Guarde todos os comprovantes de despesas: </b> Softwares, equipamentos, internet profissional — podem ser deduzidos e reduzem a base do imposto</>,
                <><b>Acompanhe seu faturamento acumulado no ano: </b> Se estiver se aproximando de R$ 360 mil, é hora de conversar com o contador sobre o próximo passo</>,
            ]} />

            <Obs texto="Com um contador especializado em freelancers PJ, a maior parte dessa rotina é automatizada. Você recebe lembretes, as guias são geradas e entregues, e você só precisa aprovar e pagar. É exatamente o que a ContBlack faz." />

            <Footer />
        </>
    )
}

export default FreelancerPj;